import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_CONSULTAS_SAP}`

export default () => http.get(`${api}/deptselect`)
